import { render, staticRenderFns } from "./ConfigAndonsList.vue?vue&type=template&id=9ab0e70a&scoped=true&"
import script from "./ConfigAndonsList.vue?vue&type=script&lang=js&"
export * from "./ConfigAndonsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAndonsList.vue?vue&type=style&index=0&id=9ab0e70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab0e70a",
  null
  
)

export default component.exports